export default "__VITE_ASSET__bD$4qxfS__"